export const Config = {
  onEDU: 'On EDU',
  keyCodeQr: '0nstuD1osbyTw0n5',
};
